import { Component, OnInit, ViewChild, Input, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { GUIService } from '../../gui.service';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage } from 'ngx-elvis-ds';

export class ListDialogCommands {
  public static OPEN = ['list.dialog.open'];
  public static UPDATE = ['list.dialog.update'];
  public static CLOSE = ['list.dialog.close'];
}

@Component({
  selector: 'app-list-dialog',
  templateUrl: './list-dialog.page.html',
  styleUrls: ['./list-dialog.page.scss'],
})
export class ListDialogPage extends BasePage implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('dialog', { static: true }) listDialog: ElementRef;
  @Input() data: any = {};

  constructor(
    public sam: SAMService,
    private configSvc: ConfigService,
    public themeSvc: ThemeService,
    public guiSvc: GUIService,
  ) {
    super();
    this.subscribeListeners();
  }

  ngOnInit() {
    this.initstyle(true);
    this.themeSvc.events.subscribe(() => { this.initstyle(); });
  }

  ngAfterViewInit() {
    this.listDialog.nativeElement.addEventListener('keydown', this.initKeyboard);
  }

  ngOnDestroy() {
    this.listDialog.nativeElement.removeEventListener('keydown', this.initKeyboard);
    if (this.subscriptions.modalEventsListener) { this.subscriptions.modalEventsListener.unsubscribe(); }
  }

  onCallback() {
    this.sam.onSend({ Command: this.data.Callback.Command });
  }

  ionViewDidEnter() {
  }

  // private

  private initKeyboard = (evt: any)  => {
    const event = evt || window.event;
    const key = event.key;

    if (key && (key === 'Escape' || key === 'Esc' || key === 'Enter')) { this.onCallback(); }

    return false;
  }

  private initstyle(setDefaults: boolean = false) {
    // if (setDefaults) { if (this.theme) { this.style.theme = this.theme; } }

    // if (!this.style.theme && this.themes.activeTheme) {
    //   this.theme = this.themes.activeTheme.style;
    // }

    // if (this.theme) {
    //   if (this.theme === 'dark') {
    //     this.listDialog.nativeElement.style.setProperty('--mem-background-color', `var(--ion-color-${this.theme}`);
    //     this.listDialog.nativeElement.style.setProperty('--mem-text-color', `var(--ion-color-light)`);
    //   } else {
    //     this.listDialog.nativeElement.style.setProperty('--mem-background-color', `var(--ion-color-${this.theme}`);
    //     this.listDialog.nativeElement.style.setProperty('--mem-text-color', `var(--ion-color-medium-shade)`);
    //   }
    // }
  }

  private subscribeListeners() {
    this.subscriptions.modalEventsListener = this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
      if (ListDialogCommands.UPDATE.includes(msg.Command)) {
        this.data = msg.parms;
      }
    });
  }
}
